import { useContact } from '@/context/Contact';
import { useMemo } from 'react';

export const usePortalNavigationAvailability = () => {
  const { contactInfo, registrationStatus } = useContact();

  return useMemo(
    () => ({
      enabled: registrationStatus?.isApproved && Boolean(contactInfo?.betaParticipantStatus),
    }),
    [registrationStatus?.isApproved, contactInfo?.betaParticipantStatus],
  );
};
